import { render, staticRenderFns } from "./losssupplement.vue?vue&type=template&id=145ad610&scoped=true&"
import script from "./losssupplement.vue?vue&type=script&lang=js&"
export * from "./losssupplement.vue?vue&type=script&lang=js&"
import style0 from "./losssupplement.vue?vue&type=style&index=0&id=145ad610&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145ad610",
  null
  
)

export default component.exports